import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY, SERVICES } from "@/data/site";
import { CITY_LIST } from "@/data/cities";

export default function Footer() {
  return (
    <footer className="bg-[#122744] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img
              src={COMPANY.logo}
              alt="Peak Plumbing logo"
              className="h-14 w-auto object-contain bg-white p-1 rounded-sm"
            />
            <div className="leading-tight">
              <div className="font-display font-extrabold text-xl tracking-tight text-white">
                Peak Plumbing
              </div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#D9BF8C] font-bold mt-1">
                Strive for the Peak
              </div>
            </div>
          </div>
          <p className="text-slate-400 mt-4 text-sm leading-relaxed max-w-sm italic">
            "{COMPANY.tagline}"
          </p>
          <p className="text-slate-400 mt-3 text-sm leading-relaxed max-w-sm">
            Family-owned Michigan plumbers serving Roseville and all of Macomb County.
            Honest work, fair prices, dependable service.
          </p>

          <div className="mt-6 space-y-3 text-sm">
            <a href={`tel:${COMPANY.phoneTel}`} className="flex items-center gap-3 hover:text-orange-400 transition">
              <Phone size={15} className="text-orange-500" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-orange-400 transition">
              <Mail size={15} className="text-orange-500" /> {COMPANY.email}
            </a>
            <div className="flex items-center gap-3">
              <MapPin size={15} className="text-orange-500" /> {COMPANY.address}
            </div>
            <div className="flex items-center gap-3">
              <Clock size={15} className="text-orange-500" /> {COMPANY.hours}
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-eyebrow text-slate-400">Services</div>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <a href="#services" className="hover:text-orange-400 transition">{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-5">
          <div className="label-eyebrow text-slate-400">Service area</div>
          <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
            {CITY_LIST.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/service-areas/${c.slug}`}
                  className="text-slate-400 hover:text-[#D9BF8C] transition"
                >
                  {c.name}, MI
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-4 flex flex-wrap gap-4 text-xs">
            <Link to="/service-areas" className="text-[#D9BF8C] font-semibold hover:underline">
              All service areas →
            </Link>
          </div>

          <div className="mt-8 bg-[#1E3A5F] border border-[#2C5282] rounded-md p-5">
            <div className="font-display font-bold text-white">Have a plumbing issue?</div>
            <p className="text-sm text-slate-400 mt-1">Call our office team and we'll get you scheduled.</p>
            <a
              data-testid="footer-call-cta"
              href={`tel:${COMPANY.phoneTel}`}
              className="btn-cta mt-4 inline-flex items-center gap-2 px-4 py-2.5 text-sm"
            >
              <Phone size={14} /> {COMPANY.phone}
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#1E3A5F]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {COMPANY.name}. Michigan plumbing contractor. All rights reserved.</div>
          <div>Built for {COMPANY.region}.</div>
        </div>
      </div>
    </footer>
  );
}
